/**
 * @deprecated Use ActivitySidebarV2 instead. This component is no longer used
 * and will be removed in a future cleanup.
 */
import {Show, HStack, Box, getValueByDevice, useDevice} from 'platform/foundation';

import {useState} from 'react';

import {browserStorageKey} from '@dms/config';

import {ActivitySidebarProvider} from '../contexts/ActivitySidebarContext';
import {ActivitySidebarAction} from '../types/ActivitySidebarAction';
import {ActivitySidebarItem} from './ActivitySidebarItem';
import {ActivitySidebarMenu} from './ActivitySidebarMenu';

interface ActivitySidebarProps {
  actions: ActivitySidebarAction[];
}

export function ActivitySidebar(props: ActivitySidebarProps) {
  const device = useDevice();
  const shouldOpenActivityPanel = localStorage.getItem(browserStorageKey.SALES_ACTIVITY_PANEL_OPEN);

  const [openTab, setOpenTab] = useState(() => {
    if (shouldOpenActivityPanel === 'false') {
      return null;
    }

    if (shouldOpenActivityPanel === 'chat' && !props.actions.some((item) => item.id === 'chat')) {
      return null;
    }

    return shouldOpenActivityPanel;
  });

  const handleCloseTab = () => {
    setOpenTab(null);
    localStorage.setItem(browserStorageKey.SALES_ACTIVITY_PANEL_OPEN, 'false');
  };

  const handleToggleTab = (tabId: string) => {
    const newTab = openTab === tabId ? null : tabId;
    setOpenTab(newTab);
    localStorage.setItem(browserStorageKey.SALES_ACTIVITY_PANEL_OPEN, newTab ?? 'false');
  };

  const activeAction = props.actions.find((action) => action.id === openTab);

  return (
    <ActivitySidebarProvider handleToggleTab={handleToggleTab}>
      <Box position="relative">
        <HStack spacing={0} height="100%">
          <Show when={openTab}>
            <Box
              position={getValueByDevice(device, 'absolute', 'absolute', 'absolute', 'initial')}
              zIndex="CONTENT"
              right={12}
              width={100}
              height={getValueByDevice(device, '100%', '100%', '100%', '100%')}
              backgroundColor="general.white"
              borderRight="1px solid"
              borderColor="general.separator"
              boxShadow="elevation_3"
            >
              <ActivitySidebarItem
                title={activeAction?.label ?? ''}
                onClose={handleCloseTab}
                disablePadding={activeAction?.disablePadding}
              >
                {activeAction?.component ?? null}
              </ActivitySidebarItem>
            </Box>
          </Show>
          <ActivitySidebarMenu
            actions={props.actions}
            onClick={handleToggleTab}
            activeTab={openTab}
          />
        </HStack>
      </Box>
    </ActivitySidebarProvider>
  );
}
